import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { contactInfo } from '../data/mock';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navigation = [
    { name: 'Home', path: '/' },
    { name: 'About', path: '/about' },
    { name: 'Services', path: '/services' },
    { name: 'Results', path: '/results' },
    { name: 'Sales Proof', path: '/salesproof' },
    { name: 'Blog', path: '/blog' },
    { name: 'Contact', path: '/contact' }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <Link to="/" className="flex min-w-0 items-center gap-2 sm:gap-3" data-testid="header-home-link">
            <img 
              src="/logo.png" 
              alt="DMARKETINGCHAMP Logo" 
              className="h-8 sm:h-12 w-auto shrink-0"
              data-testid="header-logo"
            />
            <div className="min-w-0">
              <div className="text-sm sm:text-xl font-bold text-[#0D234E]" data-testid="header-brand">DMARKETINGCHAMP</div>
              <div className="text-[10px] sm:text-xs text-[#BFB47E] font-medium" data-testid="header-tagline">...Your Network, Your Future</div>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden xl:flex items-center gap-6" aria-label="Main navigation" data-testid="header-desktop-navigation">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.path}
                data-testid={`header-nav-${item.name.toLowerCase().replace(/\s+/g, '-')}`}
                aria-current={isActive(item.path) ? 'page' : undefined}
                className={`font-medium transition-colors ${
                  isActive(item.path)
                    ? 'text-[#0D234E] border-b-2 border-[#BFB47E]'
                    : 'text-gray-600 hover:text-[#0D234E]'
                }`}
              >
                {item.name}
              </Link>
            ))}
            <a
              href={contactInfo.whatsapp}
              data-testid="header-get-started"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-[#0D234E] text-white px-6 py-2.5 rounded-md font-semibold hover:bg-[#1a3a6e] transition-all duration-200 hover:shadow-lg"
            >
              Get Started
            </a>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="xl:hidden shrink-0 p-2 rounded-md text-gray-600 hover:text-[#0D234E] hover:bg-gray-100"
            data-testid="header-mobile-menu-toggle"
            aria-label={isMenuOpen ? 'Close navigation menu' : 'Open navigation menu'}
            aria-expanded={isMenuOpen}
            aria-controls="mobile-navigation"
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav id="mobile-navigation" className="xl:hidden py-4 border-t border-gray-100" aria-label="Mobile navigation" data-testid="header-mobile-navigation">
            <div className="flex flex-col space-y-4">
              {navigation.map((item) => (
                <Link
                  key={item.name}
                  to={item.path}
                  onClick={() => setIsMenuOpen(false)}
                  data-testid={`header-mobile-nav-${item.name.toLowerCase().replace(/\s+/g, '-')}`}
                  aria-current={isActive(item.path) ? 'page' : undefined}
                  className={`font-medium px-4 py-2 rounded-md transition-colors ${
                    isActive(item.path)
                      ? 'text-[#0D234E] bg-[#BFB47E] bg-opacity-20'
                      : 'text-gray-600 hover:text-[#0D234E] hover:bg-gray-50'
                  }`}
                >
                  {item.name}
                </Link>
              ))}
              <a
                href={contactInfo.whatsapp}
                data-testid="header-mobile-get-started"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-[#0D234E] text-white px-6 py-3 rounded-md font-semibold text-center hover:bg-[#1a3a6e] transition-all duration-200"
              >
                Get Started
              </a>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
